var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "brand-guidelines" }, [
    !_vm.isEditMode
      ? _c("div", [
          _c(
            "div",
            {
              staticClass:
                "d-flex align-items-center gap-4 mb-4 justify-content-between",
            },
            [
              _c(
                "div",
                { staticClass: "search-wrap flex-grow-1 position-relative" },
                [
                  _c(
                    "svg",
                    {
                      staticClass: "search-icon",
                      attrs: {
                        width: "15",
                        height: "15",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        stroke: "#aaa",
                        "stroke-width": "2",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                      },
                    },
                    [
                      _c("circle", { attrs: { cx: "11", cy: "11", r: "8" } }),
                      _vm._v(" "),
                      _c("line", {
                        attrs: { x1: "21", y1: "21", x2: "16.65", y2: "16.65" },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.searchQuery,
                        expression: "searchQuery",
                      },
                    ],
                    staticClass: "form-control search-input",
                    attrs: {
                      type: "text",
                      placeholder: "Search brand guidelines...",
                    },
                    domProps: { value: _vm.searchQuery },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.searchQuery = $event.target.value
                      },
                    },
                  }),
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  class: _vm.isCreativeStudio
                    ? "cs-lib-btn cs-lib-btn--newseq"
                    : "btn btn-teal d-flex align-items-center btn-library",
                  on: { click: _vm.openNewBrandGuideline },
                },
                [
                  _c("i", { staticClass: "bi bi-plus-lg mr-1" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("New Brand Guidelines")]),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "seq-list" },
            _vm._l(_vm.filteredBrandGuidelines, function (seq) {
              return _c(
                "div",
                {
                  key: seq.id,
                  staticClass:
                    "seq-row d-flex align-items-center justify-content-between",
                  on: {
                    mouseenter: function ($event) {
                      _vm.hoveredId = seq.id
                    },
                    mouseleave: function ($event) {
                      _vm.hoveredId = null
                    },
                  },
                },
                [
                  _c("div", { staticClass: "seq-info" }, [
                    _c(
                      "div",
                      {
                        staticClass: "seq-thumb",
                        class: {
                          "seq-thumb--empty":
                            !_vm.brandGuidelineThumbnailUrl(seq),
                        },
                      },
                      [
                        _vm.brandGuidelineThumbnailUrl(seq)
                          ? _c("img", {
                              attrs: {
                                src: _vm.brandGuidelineThumbnailUrl(seq),
                                alt: seq.brand_name,
                              },
                            })
                          : _c(
                              "svg",
                              {
                                attrs: {
                                  width: "18",
                                  height: "18",
                                  viewBox: "0 0 24 24",
                                  fill: "none",
                                  stroke: "currentColor",
                                  "stroke-width": "1.5",
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                },
                              },
                              [
                                _c("rect", {
                                  attrs: {
                                    width: "18",
                                    height: "18",
                                    x: "3",
                                    y: "3",
                                    rx: "2",
                                    ry: "2",
                                  },
                                }),
                                _vm._v(" "),
                                _c("circle", {
                                  attrs: { cx: "9", cy: "9", r: "2" },
                                }),
                                _vm._v(" "),
                                _c("path", {
                                  attrs: {
                                    d: "m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21",
                                  },
                                }),
                              ]
                            ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", [
                      _c(
                        "div",
                        { staticClass: "d-flex align-items-center gap-2 mb-1" },
                        [
                          _c("span", { staticClass: "seq-name" }, [
                            _vm._v(_vm._s(seq.brand_name)),
                          ]),
                          _vm._v(" "),
                          seq.voice
                            ? _c("span", { staticClass: "scope-tag" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(seq.voice) +
                                    "\n              "
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          seq.visual_style
                            ? _c("span", { staticClass: "scope-tag" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(seq.visual_style) +
                                    "\n              "
                                ),
                              ])
                            : _vm._e(),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "seq-slots" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "preview-meta d-flex align-items-center gap-2",
                          },
                          [
                            _c("span", { staticClass: "meta-item" }, [
                              _c(
                                "svg",
                                {
                                  staticClass: "mr-1",
                                  attrs: {
                                    width: "12",
                                    height: "12",
                                    viewBox: "0 0 12 12",
                                    fill: "none",
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d: "M9 1H3a1 1 0 00-1 1v8a1 1 0 001 1h6a1 1 0 001-1V2a1 1 0 00-1-1z",
                                      stroke: "currentColor",
                                      "stroke-width": "1.2",
                                      fill: "none",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("path", {
                                    attrs: {
                                      d: "M4 4h4M4 6h4M4 8h2",
                                      stroke: "currentColor",
                                      "stroke-width": "1",
                                      "stroke-linecap": "round",
                                    },
                                  }),
                                ]
                              ),
                              _vm._v(
                                "\n                  " +
                                  _vm._s(
                                    seq.documents_count || seq.docs_count || 0
                                  ) +
                                  " docs\n                "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "meta-item" }, [
                              _c(
                                "svg",
                                {
                                  staticClass: "mr-1",
                                  attrs: {
                                    width: "12",
                                    height: "12",
                                    viewBox: "0 0 12 12",
                                    fill: "none",
                                  },
                                },
                                [
                                  _c("rect", {
                                    attrs: {
                                      x: "1",
                                      y: "2",
                                      width: "10",
                                      height: "8",
                                      rx: "1",
                                      stroke: "currentColor",
                                      "stroke-width": "1.2",
                                      fill: "none",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("path", {
                                    attrs: {
                                      d: "M1 7.5l2.5-2.5 2 2L8 4l3 3.5",
                                      stroke: "currentColor",
                                      "stroke-width": "1",
                                      "stroke-linecap": "round",
                                    },
                                  }),
                                ]
                              ),
                              _vm._v(
                                "\n                  " +
                                  _vm._s(seq.images_count || 0) +
                                  " images\n                "
                              ),
                            ]),
                          ]
                        ),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  !_vm.isCreativeStudio && !_vm.fromAnalysis
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "seq-actions d-flex align-items-center gap-1",
                          class: { visible: _vm.hoveredId === seq.id },
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "icon-btn",
                              on: {
                                click: function ($event) {
                                  return _vm.handleBrandGuidelineEdit(seq)
                                },
                              },
                            },
                            [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    width: "14",
                                    height: "14",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    stroke: "currentColor",
                                    "stroke-width": "2",
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                  },
                                },
                                [
                                  _c("path", { attrs: { d: "M12 20h9" } }),
                                  _vm._v(" "),
                                  _c("path", {
                                    attrs: {
                                      d: "M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "icon-btn icon-btn-danger",
                              on: {
                                click: function ($event) {
                                  return _vm.handleDelete(seq.id)
                                },
                              },
                            },
                            [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    width: "14",
                                    height: "14",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    stroke: "currentColor",
                                    "stroke-width": "2",
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                  },
                                },
                                [
                                  _c("polyline", {
                                    attrs: { points: "3 6 5 6 21 6" },
                                  }),
                                  _vm._v(" "),
                                  _c("path", {
                                    attrs: {
                                      d: "M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("path", { attrs: { d: "M10 11v6" } }),
                                  _vm._v(" "),
                                  _c("path", { attrs: { d: "M14 11v6" } }),
                                  _vm._v(" "),
                                  _c("path", { attrs: { d: "M9 6V4h6v2" } }),
                                ]
                              ),
                            ]
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isCreativeStudio || _vm.fromAnalysis
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "seq-actions d-flex align-items-center gap-2",
                          class: { visible: _vm.hoveredId === seq.id },
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass:
                                "cs-lib-btn cs-lib-btn--primary cs-lib-btn--use",
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  return _vm.useBrandGuideline(seq)
                                },
                              },
                            },
                            [_vm._v("\n            Use\n          ")]
                          ),
                        ]
                      )
                    : _vm._e(),
                ]
              )
            }),
            0
          ),
          _vm._v(" "),
          _vm.isLoadingBrandGuidelines
            ? _c(
                "div",
                { staticClass: "brand-guidelines-loading" },
                [
                  _c("b-spinner", {
                    attrs: { small: "", label: "Loading..." },
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "ml-2" }, [
                    _vm._v("Loading brand guidelines..."),
                  ]),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.brandGuidelines.length === 0 && !_vm.isLoadingBrandGuidelines
            ? _c("div", { staticClass: "empty-state-panel" }, [
                _c(
                  "svg",
                  {
                    staticClass: "empty-state-panel__icon",
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "24",
                      height: "24",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                    },
                  },
                  [
                    _c("circle", {
                      attrs: {
                        cx: "13.5",
                        cy: "6.5",
                        r: ".5",
                        fill: "currentColor",
                      },
                    }),
                    _vm._v(" "),
                    _c("circle", {
                      attrs: {
                        cx: "17.5",
                        cy: "10.5",
                        r: ".5",
                        fill: "currentColor",
                      },
                    }),
                    _vm._v(" "),
                    _c("circle", {
                      attrs: {
                        cx: "8.5",
                        cy: "7.5",
                        r: ".5",
                        fill: "currentColor",
                      },
                    }),
                    _vm._v(" "),
                    _c("circle", {
                      attrs: {
                        cx: "6.5",
                        cy: "12.5",
                        r: ".5",
                        fill: "currentColor",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d: "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10c.926 0 1.648-.746 1.648-1.688 0-.437-.18-.835-.437-1.125-.29-.289-.438-.652-.438-1.125a1.64 1.64 0 0 1 1.668-1.668h1.996c3.051 0 5.555-2.503 5.555-5.554C21.965 6.012 17.461 2 12 2z",
                      },
                    }),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "empty-state-panel__title" }, [
                  _vm._v("\n        No brand guidelines yet\n      "),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "empty-state-panel__desc" }, [
                  _vm._v(
                    '\n        Click "New Brand Guidelines" to get started.\n      '
                  ),
                ]),
              ])
            : _vm.filteredBrandGuidelines.length === 0 &&
              !_vm.isLoadingBrandGuidelines
            ? _c("div", { staticClass: "empty-state-search" }, [
                _vm._v("\n      No brand guidelines found\n    "),
              ])
            : _vm._e(),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.isEditMode
      ? _c("div", { staticClass: "content-area" }, [
          _c("div", { staticClass: "edit-top-bar" }, [
            _c(
              "button",
              {
                staticClass: "btn-edit-back",
                attrs: { type: "button" },
                on: { click: _vm.cancel },
              },
              [
                _c(
                  "svg",
                  {
                    attrs: {
                      width: "14",
                      height: "14",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                    },
                  },
                  [
                    _c("path", { attrs: { d: "m12 19-7-7 7-7" } }),
                    _vm._v(" "),
                    _c("path", { attrs: { d: "M19 12H5" } }),
                  ]
                ),
                _vm._v("\n        Back\n      "),
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn-edit-save",
                attrs: { type: "button", disabled: _vm.saveButtonDisabled },
                on: { click: _vm.save },
              },
              [
                _c(
                  "svg",
                  {
                    attrs: {
                      width: "14",
                      height: "14",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                    },
                  },
                  [_c("path", { attrs: { d: "M20 6 9 17l-5-5" } })]
                ),
                _vm._v("\n        Save\n      "),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "edit-grid" }, [
            _c("div", { staticClass: "edit-main" }, [
              !_vm.assistantMode
                ? _c("div", { staticClass: "edit-form" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _c(
                        "label",
                        {
                          staticClass: "field-label",
                          attrs: { for: "brand-name" },
                        },
                        [_vm._v("Brand name")]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.brandName,
                            expression: "form.brandName",
                          },
                        ],
                        staticClass: "form-control field-input",
                        attrs: {
                          id: "brand-name",
                          type: "text",
                          placeholder: "e.g. Marie Callender's — Frozen",
                        },
                        domProps: { value: _vm.form.brandName },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(_vm.form, "brandName", $event.target.value)
                          },
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c("label", { staticClass: "field-label" }, [
                          _vm._v("Thumbnail"),
                        ]),
                        _vm._v(" "),
                        _c("ImageGroupUploadZone", {
                          attrs: { variant: "lovable", multiple: false },
                          on: { "add-files": _vm.addThumbnailFiles },
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "field-hint" }, [
                          _vm._v(
                            "\n              Shown next to the brand name in the library list.\n            "
                          ),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group" }, [
                      _c("div", { staticClass: "assets-label-row" }, [
                        _c("label", { staticClass: "field-label mb-0" }, [
                          _vm._v("Brand assets"),
                        ]),
                        _vm._v(" "),
                        _vm.processingFileCount > 0
                          ? _c(
                              "span",
                              { staticClass: "assets-processing-label" },
                              [
                                _c("b-spinner", {
                                  staticClass: "mr-1",
                                  attrs: { small: "" },
                                }),
                                _vm._v(
                                  "\n                Parsing " +
                                    _vm._s(_vm.processingFileCount) +
                                    " file" +
                                    _vm._s(
                                      _vm.processingFileCount === 1 ? "" : "s"
                                    ) +
                                    "...\n              "
                                ),
                              ],
                              1
                            )
                          : _vm.needsBrandNameForAssets
                          ? _c(
                              "span",
                              { staticClass: "assets-brandname-hint" },
                              [
                                _vm._v(
                                  "\n                Add a brand name to enable parsing\n              "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "upload-dropzone",
                          class: { "upload-dropzone--active": _vm.isDragOver },
                          on: {
                            click: _vm.openBrandAssetsPicker,
                            dragover: function ($event) {
                              $event.preventDefault()
                              _vm.isDragOver = true
                            },
                            dragleave: function ($event) {
                              $event.preventDefault()
                              _vm.isDragOver = false
                            },
                            drop: function ($event) {
                              $event.preventDefault()
                              return _vm.handleBrandAssetsDrop.apply(
                                null,
                                arguments
                              )
                            },
                          },
                        },
                        [
                          _c(
                            "svg",
                            {
                              staticClass: "upload-dropzone__icon",
                              attrs: {
                                width: "20",
                                height: "20",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                "stroke-width": "2",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                              },
                            },
                            [
                              _c("path", {
                                attrs: {
                                  d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4",
                                },
                              }),
                              _vm._v(" "),
                              _c("polyline", {
                                attrs: { points: "17 8 12 3 7 8" },
                              }),
                              _vm._v(" "),
                              _c("line", {
                                attrs: {
                                  x1: "12",
                                  x2: "12",
                                  y1: "3",
                                  y2: "15",
                                },
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "upload-dropzone__title" }, [
                            _vm._v(
                              "\n                Drop brand docs or images here\n              "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "upload-dropzone__hint" }, [
                            _vm._v(
                              "\n                PDF, DOCX, PPTX, images — we'll extract guidelines automatically\n              "
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        ref: "brandAssetsInput",
                        staticClass: "d-none",
                        attrs: {
                          type: "file",
                          multiple: "",
                          accept:
                            ".pdf,.doc,.docx,.ppt,.pptx,.txt,.md,.rtf,image/*",
                        },
                        on: { change: _vm.handleBrandAssetsSelected },
                      }),
                      _vm._v(" "),
                      _vm.uploadedAssets.length
                        ? _c(
                            "div",
                            { staticClass: "asset-list" },
                            _vm._l(_vm.uploadedAssets, function (asset, index) {
                              return _c(
                                "div",
                                {
                                  key: _vm.getAttachmentKey(
                                    asset,
                                    index,
                                    asset.type
                                  ),
                                  staticClass: "asset-row",
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "asset-row__icon" },
                                    [
                                      asset.type === "document"
                                        ? _c(
                                            "svg",
                                            {
                                              attrs: {
                                                width: "16",
                                                height: "16",
                                                viewBox: "0 0 24 24",
                                                fill: "none",
                                                stroke: "currentColor",
                                                "stroke-width": "2",
                                                "stroke-linecap": "round",
                                                "stroke-linejoin": "round",
                                              },
                                            },
                                            [
                                              _c("path", {
                                                attrs: {
                                                  d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z",
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("path", {
                                                attrs: {
                                                  d: "M14 2v4a2 2 0 0 0 2 2h4",
                                                },
                                              }),
                                            ]
                                          )
                                        : asset.url
                                        ? _c("img", {
                                            staticClass: "asset-row__thumb",
                                            attrs: {
                                              src: asset.url,
                                              alt: asset.name,
                                            },
                                          })
                                        : _c(
                                            "svg",
                                            {
                                              attrs: {
                                                width: "16",
                                                height: "16",
                                                viewBox: "0 0 24 24",
                                                fill: "none",
                                                stroke: "currentColor",
                                                "stroke-width": "2",
                                                "stroke-linecap": "round",
                                                "stroke-linejoin": "round",
                                              },
                                            },
                                            [
                                              _c("rect", {
                                                attrs: {
                                                  width: "18",
                                                  height: "18",
                                                  x: "3",
                                                  y: "3",
                                                  rx: "2",
                                                  ry: "2",
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("circle", {
                                                attrs: {
                                                  cx: "9",
                                                  cy: "9",
                                                  r: "2",
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("path", {
                                                attrs: {
                                                  d: "m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21",
                                                },
                                              }),
                                            ]
                                          ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "asset-row__info" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "asset-row__name" },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(asset.name) +
                                              "\n                  "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      asset.size
                                        ? _c(
                                            "div",
                                            { staticClass: "asset-row__size" },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    _vm.formatFileSize(
                                                      asset.size
                                                    )
                                                  ) +
                                                  "\n                  "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "asset-row__actions" },
                                    [
                                      asset.status === "parsing"
                                        ? _c(
                                            "span",
                                            {
                                              staticClass:
                                                "asset-badge asset-badge--processing",
                                            },
                                            [
                                              _c("b-spinner", {
                                                staticClass: "mr-1",
                                                attrs: { small: "" },
                                              }),
                                              _vm._v(
                                                "\n                    Parsing\n                  "
                                              ),
                                            ],
                                            1
                                          )
                                        : [
                                            _c(
                                              "span",
                                              {
                                                staticClass: "asset-badge",
                                                class:
                                                  asset.status === "failed"
                                                    ? "asset-badge--failed"
                                                    : "asset-badge--ready",
                                              },
                                              [
                                                asset.status !== "failed"
                                                  ? _c(
                                                      "svg",
                                                      {
                                                        attrs: {
                                                          width: "12",
                                                          height: "12",
                                                          viewBox: "0 0 24 24",
                                                          fill: "none",
                                                          stroke:
                                                            "currentColor",
                                                          "stroke-width": "2.5",
                                                          "stroke-linecap":
                                                            "round",
                                                          "stroke-linejoin":
                                                            "round",
                                                        },
                                                      },
                                                      [
                                                        _c("path", {
                                                          attrs: {
                                                            d: "M20 6 9 17l-5-5",
                                                          },
                                                        }),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      asset.status === "failed"
                                                        ? "Failed"
                                                        : "Ready"
                                                    ) +
                                                    "\n                    "
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "button",
                                              {
                                                staticClass: "btn-insert",
                                                attrs: {
                                                  type: "button",
                                                  disabled:
                                                    asset.status ===
                                                      "parsing" ||
                                                    !_vm.hasBrandName,
                                                  title: !_vm.hasBrandName
                                                    ? "Enter a brand name first"
                                                    : null,
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.insertExtractedContent(
                                                      asset
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "svg",
                                                  {
                                                    attrs: {
                                                      width: "12",
                                                      height: "12",
                                                      viewBox: "0 0 24 24",
                                                      fill: "none",
                                                      stroke: "currentColor",
                                                      "stroke-width": "2",
                                                      "stroke-linecap": "round",
                                                      "stroke-linejoin":
                                                        "round",
                                                    },
                                                  },
                                                  [
                                                    _c("path", {
                                                      attrs: {
                                                        d: "M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z",
                                                      },
                                                    }),
                                                    _vm._v(" "),
                                                    _c("path", {
                                                      attrs: { d: "M20 3v4" },
                                                    }),
                                                    _vm._v(" "),
                                                    _c("path", {
                                                      attrs: { d: "M22 5h-4" },
                                                    }),
                                                    _vm._v(" "),
                                                    _c("path", {
                                                      attrs: { d: "M4 17v2" },
                                                    }),
                                                    _vm._v(" "),
                                                    _c("path", {
                                                      attrs: { d: "M5 18H3" },
                                                    }),
                                                  ]
                                                ),
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      _vm.hasExtractedSection(
                                                        asset.name
                                                      )
                                                        ? "Insert again"
                                                        : "Insert"
                                                    ) +
                                                    "\n                    "
                                                ),
                                              ]
                                            ),
                                          ],
                                      _vm._v(" "),
                                      _c(
                                        "button",
                                        {
                                          staticClass: "asset-row__remove",
                                          attrs: {
                                            type: "button",
                                            title: "Remove",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.removeBrandAsset(index)
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "svg",
                                            {
                                              attrs: {
                                                width: "14",
                                                height: "14",
                                                viewBox: "0 0 24 24",
                                                fill: "none",
                                                stroke: "currentColor",
                                                "stroke-width": "2",
                                                "stroke-linecap": "round",
                                                "stroke-linejoin": "round",
                                              },
                                            },
                                            [
                                              _c("path", {
                                                attrs: { d: "M18 6 6 18" },
                                              }),
                                              _vm._v(" "),
                                              _c("path", {
                                                attrs: { d: "m6 6 12 12" },
                                              }),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ],
                                    2
                                  ),
                                ]
                              )
                            }),
                            0
                          )
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group" }, [
                      _c("div", { staticClass: "guidelines-label-row" }, [
                        _c(
                          "label",
                          {
                            staticClass: "field-label mb-0",
                            attrs: { for: "brand-guidelines" },
                          },
                          [_vm._v("Guidelines")]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn-use-template",
                            attrs: { type: "button" },
                            on: { click: _vm.useGuidelinesTemplate },
                          },
                          [
                            _c(
                              "svg",
                              {
                                attrs: {
                                  width: "12",
                                  height: "12",
                                  viewBox: "0 0 24 24",
                                  fill: "none",
                                  stroke: "currentColor",
                                  "stroke-width": "2",
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                },
                              },
                              [
                                _c("path", {
                                  attrs: {
                                    d: "M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z",
                                  },
                                }),
                                _vm._v(" "),
                                _c("path", { attrs: { d: "M20 3v4" } }),
                                _vm._v(" "),
                                _c("path", { attrs: { d: "M22 5h-4" } }),
                                _vm._v(" "),
                                _c("path", { attrs: { d: "M4 17v2" } }),
                                _vm._v(" "),
                                _c("path", { attrs: { d: "M5 18H3" } }),
                              ]
                            ),
                            _vm._v(
                              "\n                Use template\n              "
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.guidelines,
                            expression: "form.guidelines",
                          },
                        ],
                        staticClass:
                          "form-control field-textarea field-textarea--mono",
                        attrs: {
                          id: "brand-guidelines",
                          placeholder: _vm.guidelinesPlaceholder,
                          rows: "12",
                        },
                        domProps: { value: _vm.form.guidelines },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.form,
                              "guidelines",
                              $event.target.value
                            )
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "field-hint" }, [
                        _vm._v(
                          "\n              Free-form — paste, type, or let uploads fill this in. Edit anything that comes out of processing.\n            "
                        ),
                      ]),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("input", {
                ref: "documentsInput",
                staticClass: "d-none",
                attrs: {
                  type: "file",
                  multiple: "",
                  accept: ".pdf,.doc,.docx,.txt,.csv,.xlsx,.ppt,.pptx",
                },
                on: { change: _vm.handleDocumentsSelected },
              }),
              _vm._v(" "),
              _c("input", {
                ref: "imagesInput",
                staticClass: "d-none",
                attrs: { type: "file", multiple: "", accept: "image/*" },
                on: { change: _vm.handleImagesSelected },
              }),
              _vm._v(" "),
              _vm.assistantMode
                ? _c("div", { staticClass: "bga-shell" }, [
                    _c("div", { staticClass: "bga-header" }, [
                      _vm._m(0),
                      _vm._v(" "),
                      _c("div", { staticClass: "bga-header__right" }, [
                        _c("span", { staticClass: "bga-btn--ready-save" }, [
                          _vm._v(_vm._s(_vm.assistantStepLabel)),
                        ]),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "bga-btn bga-btn--outline",
                            staticStyle: { border: "none" },
                            on: {
                              click: function ($event) {
                                _vm.assistantMode = false
                              },
                            },
                          },
                          [_vm._v("\n                Use form\n              ")]
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { ref: "messageList", staticClass: "bga-messages" },
                      [
                        _c(
                          "transition-group",
                          {
                            staticClass: "bga-messages__inner",
                            attrs: { name: "bga-msg", tag: "div" },
                          },
                          _vm._l(_vm.messages, function (msg) {
                            return _c(
                              "div",
                              {
                                key: msg.id,
                                staticClass: "bga-msg",
                                class: `bga-msg--${msg.type}`,
                              },
                              [
                                msg.type === "assistant"
                                  ? [
                                      _c(
                                        "div",
                                        { staticClass: "bga-msg__bubble" },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "bga-msg__text" },
                                            [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(msg.text) +
                                                  "\n                    "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  : msg.type === "user"
                                  ? [
                                      _c(
                                        "div",
                                        { staticClass: "bga-msg__bubble" },
                                        [
                                          _c(
                                            "p",
                                            { staticClass: "bga-msg__text" },
                                            [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(msg.text) +
                                                  "\n                    "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          msg.files && msg.files.length
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass: "bga-msg__files",
                                                },
                                                _vm._l(
                                                  msg.files,
                                                  function (f, fi) {
                                                    return _c(
                                                      "div",
                                                      {
                                                        key: fi,
                                                        staticClass:
                                                          "bga-file-chip",
                                                      },
                                                      [
                                                        _c(
                                                          "svg",
                                                          {
                                                            attrs: {
                                                              width: "11",
                                                              height: "11",
                                                              viewBox:
                                                                "0 0 11 11",
                                                              fill: "none",
                                                            },
                                                          },
                                                          [
                                                            _c("path", {
                                                              attrs: {
                                                                d: "M2 1h5l3 3v6a1 1 0 01-1 1H2a1 1 0 01-1-1V2a1 1 0 011-1z",
                                                                stroke:
                                                                  "currentColor",
                                                                "stroke-width":
                                                                  "1.2",
                                                                fill: "none",
                                                              },
                                                            }),
                                                            _vm._v(" "),
                                                            _c("path", {
                                                              attrs: {
                                                                d: "M7 1v3h3",
                                                                stroke:
                                                                  "currentColor",
                                                                "stroke-width":
                                                                  "1.2",
                                                                fill: "none",
                                                              },
                                                            }),
                                                          ]
                                                        ),
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(f.name) +
                                                            "\n                      "
                                                        ),
                                                      ]
                                                    )
                                                  }
                                                ),
                                                0
                                              )
                                            : _vm._e(),
                                        ]
                                      ),
                                    ]
                                  : msg.type === "typing"
                                  ? [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "bga-msg__bubble bga-msg__bubble--typing",
                                        },
                                        [
                                          _c("span", {
                                            staticClass: "bga-typing-dot",
                                          }),
                                          _vm._v(" "),
                                          _c("span", {
                                            staticClass: "bga-typing-dot",
                                          }),
                                          _vm._v(" "),
                                          _c("span", {
                                            staticClass: "bga-typing-dot",
                                          }),
                                        ]
                                      ),
                                    ]
                                  : _vm._e(),
                              ],
                              2
                            )
                          }),
                          0
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "bga-input-bar" }, [
                      _c(
                        "button",
                        {
                          staticClass: "bga-tool-btn",
                          attrs: { title: "Attach file" },
                          on: { click: _vm.triggerFileInput },
                        },
                        [
                          _c(
                            "svg",
                            {
                              attrs: {
                                width: "16",
                                height: "16",
                                viewBox: "0 0 16 16",
                                fill: "none",
                              },
                            },
                            [
                              _c("path", {
                                attrs: {
                                  d: "M13.5 7.5L7 14a4 4 0 01-5.66-5.66l7-7a2.5 2.5 0 013.54 3.54L5.4 11.35a1 1 0 01-1.41-1.41L10 4",
                                  stroke: "currentColor",
                                  "stroke-width": "1.4",
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                },
                              }),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "bga-tool-btn",
                          attrs: { title: "Attach image" },
                          on: { click: _vm.triggerImageInput },
                        },
                        [
                          _c(
                            "svg",
                            {
                              attrs: {
                                width: "16",
                                height: "16",
                                viewBox: "0 0 16 16",
                                fill: "none",
                              },
                            },
                            [
                              _c("rect", {
                                attrs: {
                                  x: "1",
                                  y: "2",
                                  width: "14",
                                  height: "12",
                                  rx: "1.5",
                                  stroke: "currentColor",
                                  "stroke-width": "1.4",
                                  fill: "none",
                                },
                              }),
                              _vm._v(" "),
                              _c("path", {
                                attrs: {
                                  d: "M1 10.5l4-4 3.5 3.5L12 6l3 4.5",
                                  stroke: "currentColor",
                                  "stroke-width": "1.4",
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  fill: "none",
                                },
                              }),
                              _vm._v(" "),
                              _c("circle", {
                                attrs: {
                                  cx: "5.5",
                                  cy: "6.5",
                                  r: "1.2",
                                  fill: "currentColor",
                                },
                              }),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "bga-input-wrap" }, [
                        _c("textarea", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.inputText,
                              expression: "inputText",
                            },
                          ],
                          ref: "textarea",
                          staticClass: "bga-textarea",
                          attrs: {
                            placeholder: _vm.inputPlaceholder,
                            rows: "1",
                          },
                          domProps: { value: _vm.inputText },
                          on: {
                            input: [
                              function ($event) {
                                if ($event.target.composing) return
                                _vm.inputText = $event.target.value
                              },
                              _vm.autoResize,
                            ],
                            keydown: [
                              function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                )
                                  return null
                                if (
                                  $event.ctrlKey ||
                                  $event.shiftKey ||
                                  $event.altKey ||
                                  $event.metaKey
                                )
                                  return null
                                $event.preventDefault()
                                return _vm.send.apply(null, arguments)
                              },
                              function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                )
                                  return null
                                if (!$event.shiftKey) return null
                                if (
                                  $event.ctrlKey ||
                                  $event.altKey ||
                                  $event.metaKey
                                )
                                  return null
                                return _vm.newline.apply(null, arguments)
                              },
                            ],
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "bga-send-btn",
                          class: { "bga-send-btn--active": _vm.canSend },
                          attrs: { title: "Send", disabled: !_vm.canSend },
                          on: { click: _vm.send },
                        },
                        [
                          _c(
                            "svg",
                            {
                              attrs: {
                                width: "15",
                                height: "15",
                                viewBox: "0 0 15 15",
                                fill: "none",
                              },
                            },
                            [
                              _c("path", {
                                attrs: {
                                  d: "M13 7.5H2M13 7.5L8.5 3M13 7.5L8.5 12",
                                  stroke: "currentColor",
                                  "stroke-width": "1.6",
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                },
                              }),
                            ]
                          ),
                        ]
                      ),
                    ]),
                  ])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c("aside", { staticClass: "live-preview" }, [
              _c("div", { staticClass: "live-preview__card" }, [
                _c("div", { staticClass: "live-preview__header" }, [
                  _c(
                    "svg",
                    {
                      staticClass: "text-primary",
                      attrs: {
                        width: "14",
                        height: "14",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        stroke: "currentColor",
                        "stroke-width": "2",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                      },
                    },
                    [
                      _c("circle", {
                        attrs: {
                          cx: "13.5",
                          cy: "6.5",
                          r: ".5",
                          fill: "currentColor",
                        },
                      }),
                      _vm._v(" "),
                      _c("circle", {
                        attrs: {
                          cx: "17.5",
                          cy: "10.5",
                          r: ".5",
                          fill: "currentColor",
                        },
                      }),
                      _vm._v(" "),
                      _c("circle", {
                        attrs: {
                          cx: "8.5",
                          cy: "7.5",
                          r: ".5",
                          fill: "currentColor",
                        },
                      }),
                      _vm._v(" "),
                      _c("circle", {
                        attrs: {
                          cx: "6.5",
                          cy: "12.5",
                          r: ".5",
                          fill: "currentColor",
                        },
                      }),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          d: "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10c.926 0 1.648-.746 1.648-1.688 0-.437-.18-.835-.437-1.125-.29-.289-.438-.652-.438-1.125a1.64 1.64 0 0 1 1.668-1.668h1.996c3.051 0 5.555-2.503 5.555-5.554C21.965 6.012 17.461 2 12 2z",
                        },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "live-preview__title" }, [
                    _vm._v("Live preview"),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "live-preview__badge" }, [
                    _vm._v("Auto"),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "live-preview__body" }, [
                  _c("div", { staticClass: "live-preview__section" }, [
                    _c("div", { staticClass: "live-preview__label" }, [
                      _vm._v("\n                Brand\n              "),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "live-preview__brand",
                        class: {
                          "live-preview__brand--empty":
                            !_vm.form.brandName.trim(),
                        },
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.previewBrandName) +
                            "\n              "
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "live-preview__section" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "live-preview__label live-preview__label--row",
                      },
                      [
                        _vm._v(
                          "\n                Logo / hero image\n                "
                        ),
                        _vm.thumbnailPreviewUrl
                          ? _c(
                              "button",
                              {
                                staticClass: "thumbnail-remove-btn",
                                attrs: { type: "button" },
                                on: { click: _vm.clearThumbnailSelection },
                              },
                              [
                                _vm._v(
                                  "\n                  Remove\n                  "
                                ),
                                _c("b-icon", {
                                  attrs: { icon: "x", "font-scale": "1.4" },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.previewHeroImage
                      ? _c("div", { staticClass: "live-preview__hero" }, [
                          _c("img", {
                            attrs: {
                              src: _vm.previewHeroImage,
                              alt: "Brand hero",
                            },
                          }),
                        ])
                      : _c(
                          "div",
                          {
                            staticClass:
                              "live-preview__hero live-preview__hero--empty",
                          },
                          [
                            _c(
                              "svg",
                              {
                                attrs: {
                                  width: "20",
                                  height: "20",
                                  viewBox: "0 0 24 24",
                                  fill: "none",
                                  stroke: "currentColor",
                                  "stroke-width": "2",
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                },
                              },
                              [
                                _c("rect", {
                                  attrs: {
                                    width: "18",
                                    height: "18",
                                    x: "3",
                                    y: "3",
                                    rx: "2",
                                    ry: "2",
                                  },
                                }),
                                _vm._v(" "),
                                _c("circle", {
                                  attrs: { cx: "9", cy: "9", r: "2" },
                                }),
                                _vm._v(" "),
                                _c("path", {
                                  attrs: {
                                    d: "m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21",
                                  },
                                }),
                              ]
                            ),
                            _vm._v(" "),
                            _c("span", [_vm._v("Upload an image to preview")]),
                          ]
                        ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "live-preview__section" }, [
                    _c("div", { staticClass: "live-preview__label" }, [
                      _vm._v("\n                Colors\n              "),
                    ]),
                    _vm._v(" "),
                    _vm.previewColors.length
                      ? _c(
                          "div",
                          { staticClass: "live-preview__colors" },
                          _vm._l(_vm.previewColors, function (color) {
                            return _c(
                              "div",
                              {
                                key: color,
                                staticClass: "live-preview__color",
                              },
                              [
                                _c("span", {
                                  staticClass: "live-preview__swatch",
                                  style: { backgroundColor: color },
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "live-preview__hex" },
                                  [_vm._v(_vm._s(color))]
                                ),
                              ]
                            )
                          }),
                          0
                        )
                      : _c("div", { staticClass: "live-preview__empty-hint" }, [
                          _vm._v(
                            "\n                Mention hex codes (e.g. #1E2761) and swatches appear here.\n              "
                          ),
                        ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "live-preview__section" }, [
                    _c("div", { staticClass: "live-preview__label" }, [
                      _vm._v("\n                Typography\n              "),
                    ]),
                    _vm._v(" "),
                    _vm.previewTypography.length
                      ? _c(
                          "div",
                          { staticClass: "live-preview__typography" },
                          _vm._l(_vm.previewTypography, function (line, index) {
                            return _c(
                              "div",
                              {
                                key: `typo-${index}`,
                                staticClass: "live-preview__typo-line",
                              },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(line) +
                                    "\n                "
                                ),
                              ]
                            )
                          }),
                          0
                        )
                      : _c("div", { staticClass: "live-preview__empty-hint" }, [
                          _vm._v(
                            '\n                Add a "Typography" section to preview fonts.\n              '
                          ),
                        ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "live-preview__stats" }, [
                    _c("span", { staticClass: "meta-item" }, [
                      _c(
                        "svg",
                        {
                          staticClass: "mr-1",
                          attrs: {
                            width: "12",
                            height: "12",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            "stroke-width": "2",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z",
                            },
                          }),
                          _vm._v(" "),
                          _c("path", {
                            attrs: { d: "M14 2v4a2 2 0 0 0 2 2h4" },
                          }),
                        ]
                      ),
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.docsCount) +
                          " docs\n              "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "meta-item" }, [
                      _c(
                        "svg",
                        {
                          staticClass: "mr-1",
                          attrs: {
                            width: "12",
                            height: "12",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            "stroke-width": "2",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                          },
                        },
                        [
                          _c("rect", {
                            attrs: {
                              width: "18",
                              height: "18",
                              x: "3",
                              y: "3",
                              rx: "2",
                              ry: "2",
                            },
                          }),
                          _vm._v(" "),
                          _c("circle", { attrs: { cx: "9", cy: "9", r: "2" } }),
                          _vm._v(" "),
                          _c("path", {
                            attrs: {
                              d: "m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21",
                            },
                          }),
                        ]
                      ),
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.imagesCount) +
                          " images\n              "
                      ),
                    ]),
                  ]),
                ]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "edit-sticky-footer" }, [
            _c("div", { staticClass: "edit-sticky-footer__inner" }, [
              _c("div", { staticClass: "edit-sticky-footer__hint" }, [
                _vm._v(
                  "\n          Upload brand assets or type guidelines, then save.\n        "
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "edit-sticky-footer__actions" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn-footer-cancel",
                    attrs: { type: "button" },
                    on: { click: _vm.cancel },
                  },
                  [_vm._v("\n            Cancel\n          ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn-footer-save",
                    attrs: { type: "button", disabled: _vm.saveButtonDisabled },
                    on: { click: _vm.save },
                  },
                  [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "14",
                          height: "14",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                        },
                      },
                      [_c("path", { attrs: { d: "M20 6 9 17l-5-5" } })]
                    ),
                    _vm._v("\n            Save brand guidelines\n          "),
                  ]
                ),
              ]),
            ]),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "bga-header__left" }, [
      _c("span", { staticClass: "bga-header__icon" }, [
        _c("i", { staticClass: "bi bi-stars" }),
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "bga-header__title" }, [
        _vm._v("Brand Guidelines Assistant"),
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "bga-header__badge" }, [_vm._v("Beta")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }